import { Button, Stack } from '@mui/material';
import { saveAs } from "file-saver";
import { useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import Page from 'src/components/Page';
import PrintOrderForm from 'src/views/print/print-order';
import * as XLSX from "xlsx";
import { apiService } from '../../../api/axiosClient';

function FormOrder() {
    const [searchParams, setSearchParams] = useSearchParams();
    const orderids = searchParams.get("orderids") || "";
    const [malls, setMalls] = useState({});
    const [list, setList] = useState([]);
    const tableRef = useRef(null); 

    const handlePrint = () => {
        window.print();
    };

    const mallsHandler = async () => {
        const response = await apiService.get('/malls')
        setMalls(response.data.data);
    }

    useEffect(() => {
        mallsHandler();
    }, []);

    const getCartInfo = async (k) => {
        await apiService.get(`/carts/items/${k}`)
        .then(response => {
            const payload = response.data;
            setList(prevList => [...prevList, { k, list: payload.list }]);
        })
        .catch(error => {
            // 에러는 이제 axiosClient의 interceptor에서 자동으로 처리됩니다
            console.error('API Error:', error);
        });
    }

    useEffect(() => {
        if (!orderids) {
            console.error('Order IDs are missing');
            return;
        }
    
        const orderIdsArray = orderids.split(',');
        if (orderIdsArray.length === 0) {
            console.error('No valid order IDs found');
            return;
        }

        orderIdsArray.forEach(orderid => {
            getCartInfo(orderid);
        })
    }, [orderids])

    const PrintContent = ({ malls, list }) => (
        <div ref={tableRef}>
            {list.map((item, index) => (
                <div key={index}>
                    {index > 0 && <div style={{ pageBreakBefore: 'always' }}></div>}
                    <PrintOrderForm malls={malls} list={item.list} key={index} />
                </div>
            ))}
        </div>
    );

    const handleExcel = () => {
        if (!tableRef.current) return;
    
        // Convert HTML table to worksheet
        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.table_to_sheet(tableRef.current);
        XLSX.utils.book_append_sheet(workbook, worksheet, "거래명세서");
    
        // Generate Excel file and trigger download
        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
        const data = new Blob([excelBuffer], { type: "application/vnd.ms-excel" });
        saveAs(data, "거래명세서.xlsx");
    };

    return (
        <Page title="거래명세서">
            <style>
                {`
                    @media print {
                        .no-print {
                            display: none;
                        }
                    }
                `}
            </style>
            <PrintContent malls={malls} list={list} />
            <Stack className="no-print" display="flex" justifyContent="center" direction="row" spacing={2} py={8}>
                <Button variant='contained' onClick={handlePrint} color="primary">
                    프린트
                </Button>
                <Button variant='contained' onClick={handleExcel} color="warning">
                    다운로드
                </Button>
            </Stack>
        </Page>
    )
}

export default FormOrder